import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=dee140e6&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=dee140e6&prod&scoped=true&lang=css&"
import style1 from "./DashboardCard.vue?vue&type=style&index=1&id=dee140e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee140e6",
  null
  
)

export default component.exports